module.exports = __webpack_public_path__ + "static/media/fundRequest.fc074ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/fundRequest.png
// module id = 1858
// module chunks = 147